var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadebro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.13 128.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0073bc;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128.13,
    height: 128.13,
    rx: 64.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.25,64.37h42.07c3.22,0,3.23-5,0-5H73.25c-3.21,0-3.22,5,0,5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 40.3,
    cy: 42.44,
    r: 6.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.84,81.29c-.38-.19-.74-.38-1.1-.6a13.45,13.45,0,0,1-2-1.66c-3.06-2.81-7-4.25-11.12-3.22a15.4,15.4,0,0,0-5.18,2.52,24,24,0,0,1-4.64,3.06,6.33,6.33,0,0,1-3.6.47A9.29,9.29,0,0,1,74,79.38c-3.14-2.83-6.93-4.54-11.21-3.83a12.93,12.93,0,0,0-4.85,2c-1.54,1-2.79,2.37-4.4,3.26a6.94,6.94,0,0,1-7.75-.49c-1.45-1-2.62-2.34-4.21-3.18a14.15,14.15,0,0,0-5.34-1.58c-4.12-.4-7.7,1.41-10.53,4.26a7.92,7.92,0,0,1-3.05,2,6.4,6.4,0,0,1-1.61.18c-1.66-.11-3.22.41-3.69,2.09-.39,1.44.49,3.43,2.1,3.69h0a11.69,11.69,0,0,0,6.69-1,15.38,15.38,0,0,0,4.46-3.39,6.11,6.11,0,0,1,3.11-1.7,7.09,7.09,0,0,1,3.74.2,11.45,11.45,0,0,1,3.73,2.43,13.56,13.56,0,0,0,10.93,3.26,13.27,13.27,0,0,0,4.94-1.85c1.56-1,2.81-2.35,4.39-3.28a6.26,6.26,0,0,1,3.85-1,5.58,5.58,0,0,1,1.65.4,9,9,0,0,1,2.2,1.33c1.69,1.36,3.15,2.85,5.16,3.74a11.75,11.75,0,0,0,5.57,1.09,14.23,14.23,0,0,0,5.65-1.68c1.7-.89,3.08-2.18,4.67-3.22a7.75,7.75,0,0,1,4.71-1.56,5.11,5.11,0,0,1,2,.64,11.52,11.52,0,0,1,2.3,1.82,14.71,14.71,0,0,0,8.63,4,3,3,0,0,0,3-3A2.93,2.93,0,0,0,108,82,6.44,6.44,0,0,1,105.84,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.08,78h.11a3.18,3.18,0,0,0,1.1-.25A13.44,13.44,0,0,0,83,75.94l1.15-.85a20.23,20.23,0,0,1,4.57-2.51V64.75a5,5,0,0,0-10,0V77.83A2.65,2.65,0,0,0,79.08,78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.6,77.1a14.15,14.15,0,0,0-5.34-1.58,11,11,0,0,0-1.13-.06c-.18,0-.34,0-.52,0L35,80l9.45-.76A16.18,16.18,0,0,0,41.6,77.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,72.38h0l17-9.25a.36.36,0,0,1,.53.29l.71,8.08c.29,0,.58-.05.87-.05.5,0,1,0,1.51.08a18.16,18.16,0,0,1,6.82,2,18.68,18.68,0,0,1,3.33,2.38c.46.4.9.77,1.32,1.07a3.49,3.49,0,0,0,2,.72,3,3,0,0,0,1.13-.25l-.43-15.65a.38.38,0,0,1,.54-.36l4.75,2a.81.81,0,0,1,.49.77L56.38,70a2.92,2.92,0,0,0,1.94,2.79,16.7,16.7,0,0,1,3.41-1.1,2.78,2.78,0,0,0,.48-1.16h0l1.77-8a3.15,3.15,0,0,0-1.53-3.43L48.38,51.13a3.71,3.71,0,0,0-1.93-.47L36.5,51a3.54,3.54,0,0,0-1.84.61L12.84,66.73l-.26.18-.06,0h0a3.19,3.19,0,0,0-1.25,2.5,3.24,3.24,0,0,0,3.2,3.29A3.3,3.3,0,0,0,16,72.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadebro);
export default __webpack_public_path__ + "static/media/BADEBRO.84d1b57275906612276f6d06e55cfe10.svg";
export { ForwardRef as ReactComponent };